import React, { Component } from 'react'
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom'
import * as Sentry from '@sentry/browser';

import { PaginationContext } from '../../context/pagination'
import { NextDisabledContext } from '../../context/nextDisabled'

import File from './questions'
import ProfilePage from './personal_profile'
import ProfileComplete from './personal_profile_complete'
import queryString from 'query-string'
import FetchWrapper from '../../utils/fetch_wrapper'

import config from '../../utils/config'

class Profile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      qnaData: null,
      mostRecentPage: 1,
      nextDisabled: false,
      backDisabled: false,
      profileComplete: false
    }
    this.updateActivePage = this._updateActivePage.bind(this)
    this.updateHistory = this._updateHistory.bind(this)
    this.addErrorLog = this._addErrorLog.bind(this)
    document.title = "Personal Profile"
  }

  static getPageCount() {
    try {
      return 6
    } catch(error) {
      this.addErrorLog(error)
    }
  }

  _updateActivePage(n) {
    try {
      this.context.updateActivePage(this.props.match.path, n)
    } catch(error) {
      this.addErrorLog(error)
    }
  }

  async componentDidMount() {
    try {
      const plId = queryString.parse(window.location.search).plId
      let profileComplete = this.state.profileComplete
      if (!profileComplete)
        await this.props.getStepCompleted(plId)
      const qnaData = await this.getQnA(plId)
      let mostRecentPage = this.state.mostRecentPage
      if (qnaData) {
        for (let data in qnaData) {
          let pageNum = qnaData[data].pageNumber
          if (pageNum > 2) pageNum--
          if (pageNum > mostRecentPage) {
            mostRecentPage = pageNum
          }
        }
        mostRecentPage++
      }
      this.setState({ loading: false, qnaData, mostRecentPage })
    } catch(error) {
      this.addErrorLog(error)
    }
  }

  componentDidUpdate() {
    try {
      if (this.shouldRedirect()) {
        let result = this.props.setShouldRedirect(true)
        if (result) this.setState({ nextDisabled: false })
      } else {
        this.props.setShouldRedirect(false)
      }
    } catch(error) {
      this.addErrorLog(error)
    }
  }

  async _backPage(history, cur, state, pageNum) {
    try {
      if (this.state.nextDisabled) return null
      this.setState({
        backDisabled: true
      }, async () => {
        await this.upsert(state, pageNum)
        this.setState({ backDisabled: false })
        switch(cur) {
          case '/1':
            return undefined
          case '/2':
            return history.goBack()
          case '/3':
            return history.goBack()
          case '/4':
            return history.goBack()
          case '/5':
            return history.goBack()
          case '/6':
            return history.goBack()
          default: return null
        }
      })
    } catch(error) {
      this.addErrorLog(error)
    }
  }

  _updateHistory(state, history) {
    try {
      const newHistory = { 
        ...history.location.state,
        ...state.input
      }
      history.replace(history.location.pathname + history.location.search, newHistory)
    } catch(error) {
      this.addErrorLog(error)
    }
  }

  setNextClicked(history) {
    try {
      let newHistory = {
        ...history.location.state,
        nextClicked: true
      }
      history.replace(history.location.pathname + history.location.search, newHistory)
    } catch(error) {
      this.addErrorLog(error)
    }
  } 

  async _nextPage(history, cur, state, pageNum) {
    try {
      if (this.state.nextDisabled) return null
      this.setState({
        nextDisabled: true
      }, async () => {
        const historyState = history.location.state
        let upserted = await this.upsert(state, pageNum)
        if (!upserted) {
          return
        }
        if (historyState && historyState.nextClicked) {
          this.setState({ nextDisabled: false })
          return history.go(1)
        }
        const plId = queryString.parse(history.location.search).plId
        this.updateHistory(state, history)
        this.setNextClicked(history)
        switch(cur) {
          case '/1':
            this.setState({ nextDisabled: false })
            return history.push('/2' + history.location.search)
          case '/2':
            this.setState({ nextDisabled: false })
            return history.push('/3' + history.location.search)
          case '/3':
            this.setState({ nextDisabled: false })
            return history.push('/4' + history.location.search)
          case '/4':
            this.setState({ nextDisabled: false })
            return history.push('/5' + history.location.search)
          case '/5':
            this.setState({ nextDisabled: false })
            return history.push('/6' + history.location.search)
          case '/6':
            this.setState({ profileComplete: true })
            if (window.location.pathname !== '/profile/6') return null
            return history.push('/complete' + history.location.search)
          default: return null
        }
      })
    } catch(error) {
      this.addErrorLog(error)
    }
  }

  async upsert(pageState, pageNum) {
    try {
      const qna = this.serializeQnA(pageState, pageNum)
      const code = queryString.parse(this.props.location.search)
      let pageNumber = pageNum
      if (pageNum >= 2) pageNumber++
      const params = {
        stringifiedQuestions: JSON.stringify(qna.questions),
        stringifiedAnswers: JSON.stringify(qna.answers),
        pageNumber,
        plId: parseInt(code.plId)
      }
      let response = await FetchWrapper.fetch(config.endpoint_upsert_qna, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(params)
      })
      return true
    } catch(error) {
      this.addErrorLog(error)
      this.setState({
        nextDisabled: false,
        verError: true
      })
      return false
    }
  }

  serializeQnA(pageState, pageNum) {
    let questions = {}
    let answers = {}
    let i = pageNum - 1
    File.pages[i].questions.map(question => {
      if (!pageState[question.key].required) return
      questions[question.key] = { text: question.text, title: File.pages[i].title }
      switch(pageState[question.key].type) {
        case 'radio':
          for (let index in question.fields) {
            if (question.fields[index].value === pageState[question.key].value) {
              answers[question.key] = [{ value: pageState[question.key].value, text: question.fields[index].text, id: question.fields[index].id, upsertKey: question.fields[index].upsertKey }]
              break
            }
          }
        break
        case 'text':
          if (pageState[question.key].value !== '') {
            answers[question.key] = [{ value: pageState[question.key].value, text: pageState[question.key].value, id: question.id, upsertKey: question.upsertKey }]
          }
        break
        case 'checkbox':
          let firstEntry = false
          for (let index in question.fields) {
            if (!firstEntry && pageState[question.key].value[question.fields[index].value]) {
              answers[question.key] = [{ value: question.fields[index].value, text: question.fields[index].text, id: question.fields[index].id, upsertKey: question.fields[index].upsertKey }]
              firstEntry = true
            } else if (pageState[question.key].value[question.fields[index].value]) {
              answers[question.key].push({ value: question.fields[index].value, text: question.fields[index].text, id: question.fields[index].id, upsertKey: question.fields[index].upsertKey })
            }  
          }
        break
        default: break
      }
    })
    return { answers, questions }
  }

  async processProfile(code) {
    try {
      const params = {
        plId: parseInt(code.plId),
        regCode: code.regCode,
        nextStepUrl: window.location.origin
      }
      let response = await FetchWrapper.fetch(config.endpoint_process_profile, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(params)
      })

      return true
    } catch(error) {
      this.addErrorLog(error)
      return false
    }
  }

  async getQnA(plId) {
    try {
      const params = {
        plId: parseInt(plId),
        page: 'profile'
      }
      let response = await FetchWrapper.fetch(config.endpoint_get_qna, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(params)
      })
      return this.deserializeQnA(response.data)
    } catch(error) {
      this.addErrorLog(error)
      return false
    }
  }

  deserializeQnA(data) {
    let newData = {}
    for (let property in data) {
      newData[property] = { value: data[property]['answerValue'], pageNumber: data[property]['pageNumber'] }
    }
    return newData
  }

  _addErrorLog(ex) {
    const newError = ex || new Error('no message')
    newError.message = ex.message || 'no message'
    if (!!queryString.parse(window.location.search).plId) {
      const addExtra = {
        userId: queryString.parse(window.location.search).plId || ''
      }
      Sentry.setExtras(addExtra)
      Sentry.setUser({ id: queryString.parse(window.location.search).plId })
    }
    Sentry.captureException(newError)
  }

  shouldRedirect() {
    try {
      if (!this.props.nextStepPath) return true
      const n = this.props.nextStepPath.search('\\?')
      let nextPath = this.props.nextStepPath.substring(0, n)
      if ((nextPath === '/profile/1' && window.location.pathname === '/profile/1') ||
          (nextPath === '/profile/1' && window.location.pathname === '/profile/2') ||
          (nextPath === '/profile/1' && window.location.pathname === '/profile/3') ||
          (nextPath === '/profile/1' && window.location.pathname === '/profile/4') ||
          (nextPath === '/profile/1' && window.location.pathname === '/profile/5') ||
          (nextPath === '/profile/1' && window.location.pathname === '/profile/6') ||
          (nextPath === '/profile/1' && window.location.pathname === '/profile/complete')) {
        return false
      }
      return true
    } catch(error) {
      this.addErrorLog(error)
    }
  }

  extendRoute(R, index) {
    try {
      return props => {
        return <R 
          {...props}
          {...File.pages[index-1]}
          pageNumber={index}
          updateActivePage={this.updateActivePage}
          processProfile={this.processProfile}
          updateHistory={this.updateHistory}
          addErrorLog={this.addErrorLog}
          qnaData={this.state.qnaData}
          mostRecentPage={this.state.mostRecentPage}
          verError={this.state.verError}
          back={this._backPage.bind(this, props.history)}
          next={this._nextPage.bind(this, props.history)}
        />
      }
    } catch(error) {
      this.addErrorLog(error)
    }
  }
  
  render() {
    try {
      const {loading, nextDisabled, backDisabled} = this.state
      if (loading) return <div></div>
      let providerValue = {
        nextDisabled,
        backDisabled
      }
      return (
        <div id="profile">
          <NextDisabledContext.Provider value={providerValue}>
            <Router basename={this.props.match.path}>
              <Switch>
                <Route path="/1" render={this.extendRoute(ProfilePage, 1)} />
                <Route path="/2" render={this.extendRoute(ProfilePage, 2)} />
                <Route path="/3" render={this.extendRoute(ProfilePage, 3)} />
                <Route path="/4" render={this.extendRoute(ProfilePage, 4)} />
                <Route path="/5" render={this.extendRoute(ProfilePage, 5)} />
                <Route path="/6" render={this.extendRoute(ProfilePage, 6)} />
                <Route path="/complete" render={this.extendRoute(ProfileComplete)} />
              </Switch>
            </Router>
          </NextDisabledContext.Provider>
        </div>
      )
    } catch(error) {
      this.addErrorLog(error)
    }  
  }
}

Profile.contextType = PaginationContext

export default Profile